import { createSlice } from "@reduxjs/toolkit";

const eventsSlice = createSlice({
  name: "events",
  initialState: {
    events: [],
    upcomingEvents: [],
    eventDetails: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    setUpcomingEvents: (state, action) => {
      state.upcomingEvents = action.payload;
    },
  },
});

export const { setUpcomingEvents } = eventsSlice.actions;
export default eventsSlice.reducer;